import { AdExternalIds } from "@smile2impress/attraction-utils";

import { getAppMode } from "utils/getAppMode";

import { sendAllFacebookAnalitic } from "./sendFacebookAnalitic";
import { sendAllGoogleAnalitic } from "./sendGoogleAnalitic";
import { AnaliticData, ExperimentData } from "./types";
import { FacebookEvents } from "./events";

export const sendAnalitic = async ({
    cityTitle,
    firstName,
    lastName,
    email,
    phone,
    locale,
    facebookLeadEventName,
    externalIds,
    ...experimentData
}: AnaliticData &
    ExperimentData & {
        facebookLeadEventName?: FacebookEvents;
        externalIds?: AdExternalIds;
    }) => {
    const { isDevMode } = getAppMode();

    if (isDevMode) return;

    await sendAllFacebookAnalitic({
        cityTitle,
        firstName,
        lastName,
        email,
        phone,
        locale,
        leadEventName: facebookLeadEventName,
    });

    sendAllGoogleAnalitic(experimentData, externalIds);
};
